import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transactionFields: [],
};

const transactionFieldSlice = createSlice({
  name: "transactionFields",
  initialState,
  reducers: {
    clearTransactionFields: (state) => {
      state.transactionFields = [];
    },
    setTransactionFields: (state, action) => {
      state.transactionFields = action.payload.map((item) => {
        return {
          fieldData: item,
          input: {
            value: item.value || null,
            filename: item.filename || '',
          },
        };
      });
    },
    updateInputTransactionFieldData: (state, action) => {
      const { index, value, filename } = action.payload;
      state.transactionFields[index].input.value = value;
      if (filename !== undefined) {
        state.transactionFields[index].input.filename = filename;
      }
    },
  },
});

export const {
  clearTransactionFields,
  setTransactionFields,
  updateInputTransactionFieldData
} = transactionFieldSlice.actions;

export default transactionFieldSlice.reducer;
